interface TextProps {
  children: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

export const Text: React.FC<TextProps> = ({ children, size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl'
  };

  return (
    <p className={`text-gray-700 ${sizeClasses[size]} ${className}`}>
      {children}
    </p>
  );
}; 